module.exports = __webpack_public_path__ + "img/video.ed16f6f6.svg";